import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonPrimary } from '@components/button/button-primary';
import { AuthContext } from '@contexts/auth/auth-context';
import { UserContext } from '@contexts/user/user-context';

export const ImpersonateUserLogOut = () => {
  const { t } = useTranslation();
  const { userState } = useContext(UserContext);
  const { resetAdminUser } = useContext(AuthContext);

  return (
    <div
      className='text-primary m-12 flex flex-col gap-5 justify-center items-center'
      data-testid='impersonate-modal--logout'>
      <p>{`${t('common:currentLoginAs')} ${userState?.firstName} ${userState?.lastName} (${userState?.email})`}</p>
      <ButtonPrimary type='button' onClick={resetAdminUser}>
        {t('common:logout')}
      </ButtonPrimary>
    </div>
  );
};
